import { StyleSheet } from "react-native";
import { mainScreen } from "../Styles/mainScreen";

export default StyleSheet.create({
  ...mainScreen,
  containerProgresso: {
    marginLeft: 15,
    borderLeftColor: "gray",
    borderLeftWidth: 3,
  },
  linhaProgresso: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: 15,
  },
  textoOk: {
    fontFamily: "Montserrat-Italic",
    paddingLeft: 10,
    color: "green",
    // fontStyle: "italic",
    fontSize: 18,
  },
  textoNok: {
    fontFamily: "Montserrat-Italic",
    paddingLeft: 10,
    color: "red",
    fontSize: 18,
  },
  pontoOk: {
    width: 30,
    height: 30,
    borderRadius: 15,

    marginLeft: -17,

    backgroundColor: "green",
  },
  pontoNok: {
    width: 30,
    height: 30,
    borderRadius: 15,

    marginLeft: -17,

    backgroundColor: "red",
    borderColor: "gray",
    borderWidth: 2,
  },
  
});
